// thir payty libraries
import moment from "moment";
import React from "react";
import {
  Form,
  Table,
  Badge,
  Dropdown,
  DropdownButton,
  Image,
} from "react-bootstrap";

// constants
import {
  COLOR_APP,
  COLOR_WHITE,
  COMPLETED,
  CREATED,
  LINK_SHOP_PAGE,
  S3_URL,
} from "../../constants";
import { convertLogicticsName, imageRender } from "../../helpers";
import {
  convertOrderStatus,
  convertOrderType,
} from "../../helpers/orderStatus";
import EmptyOrderList from "../../components/empty/EmptyOrderList";

// icons
import {
  FaCopy,
  FaEdit,
  FaEye,
  FaLuggageCart,
  FaQuestionCircle,
} from "react-icons/fa";
import { useToasts } from "react-toast-notifications";
import copy from "clipboard-copy";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { BsQuestionLg } from "react-icons/bs";
import { MdCheckCircle, MdOutlineInfo } from "react-icons/md";
import _ from "lodash";

function CreateOrderTable({
  orderGroupList,
  onSeletedAllOrder,
  setOrderGroupDownload,
  isSelectAll,
  setSelectedOrderGroup,
  handleOrderStatusChange,
  selectedIds,
  getSeletedOrder,
  gotoOrderGroupDetail,
  setshowDetailModal,
  _limit,
  _skip,
  listpage,
  setSelectedImage,
  setshowImageModal,
  getCfMessage,
  setPaySlips,
  handleCreatePreOrder,
  isUseLogistics,
  orderGroupType,
}) {
  const { addToast } = useToasts();

  const handleCopyLinkLive = async (orderId) => {
    const url = LINK_SHOP_PAGE + `order-confirm/${orderId}`;

    try {
      await copy(url);
      addToast("ກ໋ອບປີ່ລິ້ງສຳເລັດແລ້ວ!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.error("Copy failed: ", error);
    }
  };

  const mapStatusColor = (status) => {
    switch (status) {
      case "COMPLETED":
      case "SHIPPING_COMPLETED":
        return "success";
      case "CANCELLED":
        return "danger";
      case "PENDING":
        return "warning";
      case "USERCONFIRM":
        return "info";
      case "READY_TO_SHIPPING":
      case "READYTOSHIPPING":
        return "primary";
      case "PRINT_ORDER":
        return "secondary";
      default:
        return "light";
    }
  };
  const mapStatusText = (status) => {
    switch (status) {
      case "COMPLETED":
      case "SHIPPING_COMPLETED":
        return "white";
      case "CANCELLED":
        return "white";
      case "PENDING":
        return "dark";
      case "USERCONFIRM":
        return "dark";
      case "READY_TO_SHIPPING":
      case "READYTOSHIPPING":
        return "white";
      case "PRINT_ORDER":
        return "white";
      default:
        return "dark";
    }
  };

  if (orderGroupList?.length <= 0) return <EmptyOrderList />;

  return (
    <Table responsive className="order-table" style={{ minHeight: "40vh" }}>
      <thead style={{ background: COLOR_APP, color: COLOR_WHITE }}>
        <tr style={{ whiteSpace: "nowrap" }}>
          <th style={{ textAlign: "center", borderBottom: "none" }}>
            <Form.Check // prettier-ignore
              type="checkbox"
              id="ລຳດັບ"
              label="ລຳດັບ"
              checked={isSelectAll}
              onClick={() => {
                onSeletedAllOrder();
                if (isSelectAll) return setOrderGroupDownload([]);
                let _newOderGroupList = [];
                for (let _orderGroup of orderGroupList) {
                  if (_orderGroup?.orders?.length > 0)
                    _newOderGroupList.push(_orderGroup);
                }
                setOrderGroupDownload(_newOderGroupList);
              }}
            />
          </th>
          <th style={{ borderBottom: "none" }}>ເລກທີໃບສັ່ງຊື້</th>
          {/* <th style={{ borderBottom: "none" }}>ເລກບິນຂົນສົ່ງ</th> */}
          <th style={{ borderBottom: "none" }}>ຂົນສົ່ງ</th>
          <th style={{ borderBottom: "none", width: "50px" }}>ຫົວຂໍ້</th>
          <th style={{ borderBottom: "none" }}>ລູກຄ້າ</th>
          <th style={{ borderBottom: "none" }}>ຮູບຊໍາລະ</th>
          <th style={{ borderBottom: "none" }}>ປະເພດ</th>
          <th style={{ borderBottom: "none" }}>ສະຖານະ</th>
          <th style={{ borderBottom: "none" }}>ຈ່າຍຄ່າເຄື່ອງ</th>
          <th style={{ borderBottom: "none" }}>ຊໍາລະ</th>
          <th style={{ borderBottom: "none" }}>ທວງຍອດ</th>

          <th style={{ borderBottom: "none", minWidth: 100 }}>ລະຫັດ cf </th>
          {orderGroupType === "SALE_PAGE" && (
            <th style={{ borderBottom: "none", minWidth: 120 }}>ອາຟິລິເອດ</th>
          )}
          <th style={{ borderBottom: "none" }}>ລວມທັງໝົດ</th>
          <th style={{ borderBottom: "none" }}>ວັນທີ</th>
          <th style={{ width: "100px", borderBottom: "none", flex: "2" }}>
            ຈັດການ
          </th>
        </tr>
      </thead>
      <tbody>
        {orderGroupList &&
          orderGroupList.length > 0 &&
          orderGroupList.map((order, index) => {
            let _checkedOrderGroup = selectedIds.filter(
              (id) => id === order?.id,
            );
            // ຕິກເລືອກແລ້ວໃຫ້ທັງແຖວປ່ຽນສີ — ຕາຕະລາງກວ້າງ 16 ຄໍລຳ
            // ຖ້າເບິ່ງແຕ່ຊ່ອງຕິກຢູ່ຊ້າຍສຸດ ພໍເລື່ອນໄປຂວາຈະບໍ່ຮູ້ວ່າແຖວໃດເລືອກໄວ້
            const _isRowSelected = isSelectAll || _checkedOrderGroup.length > 0;
            // if (order?.orders?.length <= 0) return;
            return (
              <tr
                key={"order" + index}
                className={_isRowSelected ? "is-selected" : ""}
              >
                {isSelectAll ? (
                  <td>
                    <Form.Check
                      type="checkbox"
                      label={index + 1 + _limit * (_skip - 1)}
                      checked={true}
                      disabled
                    />
                  </td>
                ) : (
                  <td>
                    <Form.Check
                      checked={_checkedOrderGroup.length > 0}
                      onChange={() => getSeletedOrder(order?.id, order)}
                      type="checkbox"
                      id={index + 1 + _limit * (_skip - 1)}
                      label={index + 1 + _limit * (_skip - 1)}
                    />
                  </td>
                )}
                <td
                  onClick={() => {
                    setSelectedOrderGroup(order);
                    if (
                      order?.status !== COMPLETED ||
                      order?.type === "SALE_PAGE"
                    )
                      return gotoOrderGroupDetail(order?.id, order);
                  }}
                  style={{
                    color: "#371895",
                    cursor:
                      order?.status !== COMPLETED || order?.type === "SALE_PAGE"
                        ? "pointer"
                        : "default",
                    textDecoration:
                      order?.status !== COMPLETED || order?.type === "SALE_PAGE"
                        ? "underline"
                        : "none",
                  }}
                >
                  {/* ເມື່ອກ່ອນໃສ່ display:flex ໃສ່ <td> ໂດຍກົງ ຊ່ອງນີ້ຈຶ່ງຫຼຸດອອກຈາກແຖວ
                      ແລ້ວຄໍລຳທັງໝົດຂອງແຖວນັ້ນເລື່ອນບໍ່ຕົງກັບຫົວຕາຕະລາງ
                      ຍ້າຍ flex ມາໄວ້ div ຂ້າງໃນແທນ td ຈຶ່ງເປັນ table-cell ຕາມເດີມ */}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <p className="text-wrap" style={{ marginBottom: "1px" }}>
                      {order?.code ?? "-"}
                    </p>
                    <p className="text-wrap" style={{ fontSize: "12px" }}>
                      ເລກຂົນສົ່ງ: {order?.orderDelivery?.deliveryTackingNo ?? "-"}
                    </p>
                  </div>
                </td>
                <td>
                  <p style={{ minWidth: 70 }}>
                    {convertLogicticsName(
                      order?.orderDelivery?.delivery ?? "-",
                    )}
                    <span>
                      {order?.orderDelivery?.match ? (
                        <MdCheckCircle style={{ color: "green" }} />
                      ) : (
                        <MdOutlineInfo />
                      )}
                    </span>
                  </p>
                </td>
                <td
                  // ຫົວຂໍ້ໄລຟ໌/ໂພສຍາວກວ່າຊ່ອງສະເໝີ ຕັດດ້ວຍ ... ແລ້ວອ່ານບໍ່ອອກ
                  // ໃສ່ title ໄວ້ ເອົາເມົ້າຊີ້ຄ້າງກໍເຫັນຂໍ້ຄວາມເຕັມ
                  title={
                    order?.live?.description ?? order?.post?.description ?? ""
                  }
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 200,
                  }}
                >
                  {order?.live?.description ?? order?.post?.description ?? "-"}
                </td>

                <td>
                  <div className="customer-info">
                    <Image
                      alt="customer"
                      src={
                        !_.isEmpty(order?.customerImage)
                          ? order?.customerImage
                          : "../image/noPhoto.png"
                      }
                      style={{
                        width: "40px",
                        height: "40px",
                        maxWidth: "40px",
                        maxHeight: "40px",
                      }}
                      thumbnail
                    />
                    <p style={{ fontSize: "12px", marginTop: "1px" }}>
                      {order?.customerName !== "" && order?.customerName
                        ? order?.customerName
                        : order?.cfName}
                    </p>
                  </div>
                </td>
                <td>
                  {/* ບໍ່ມີສະລິບແລ້ວຍັງ render <img> ຢູ່ ຈະໄດ້ໄອຄອນຮູບແຕກເຕັມຕາຕະລາງ */}
                  {order?.paySlip ? (
                    <Image
                      alt="paments"
                      src={imageRender(order?.paySlip)}
                      style={{
                        width: 50,
                        height: 60,
                        maxWidth: 50,
                        maxHeight: 60,
                      }}
                    />
                  ) : (
                    <span style={{ color: "#9ca3af" }}>-</span>
                  )}
                </td>
                <td>{convertOrderType(order?.type)}</td>

                <td>
                  {/* <Badge bg={order?.status === "COMPLETED" ? "success" : "light"} text={order?.status === "COMPLETED" ? "white" : "dark"}>{convertOrderStatus(order?.status)}</Badge> */}
                  <Badge
                    bg={mapStatusColor(order?.status)}
                    text={mapStatusText(order?.status)}
                  >
                    {convertOrderStatus(order?.status)}
                  </Badge>
                </td>
                <td>
                  <Badge
                    bg={
                      order?.orderDelivery?.shipmentPayType === "COD"
                        ? "danger"
                        : "secondary"
                    }
                  >
                    {order?.orderDelivery?.shipmentPayType === "COD"
                      ? "ປາຍທາງ"
                      : "ຕົ້ນທາງ"}
                  </Badge>
                </td>
                <td
                  style={{
                    color: !(
                      order?.isPaymented &&
                      order?.orderDelivery?.shipmentPayType !== "COD"
                    )
                      ? "red"
                      : "green",
                    whiteSpace: "nowrap",
                    fontSize: 13,
                  }}
                >
                  {/* ສະຖານະຈ່າຍເງິນ 2 ຄ່າເທົ່ານັ້ນ — ການເຄລມເປັນການລວມຍອດ
                      ບໍ່ແມ່ນເຄລມເທື່ອລະ order ຈຶ່ງບໍ່ໂຊ "ຢູ່ບັນຊີກາງ" ຢູ່ນີ້ */}
                  {!(
                    order?.isPaymented &&
                    order?.orderDelivery?.shipmentPayType !== "COD"
                  )
                    ? "ຍັງບໍ່ຊໍາລະ"
                    : "ຊໍາລະແລ້ວ"}
                </td>
                <td>
                  {order?.confirmBalance ? (
                    <Badge bg={"success"} text={"white"}>
                      ຮັບຍອດແລ້ວ
                    </Badge>
                  ) : order?.isClaimBalance ? (
                    <IoCheckmarkDoneOutline style={{ color: "green" }} />
                  ) : order?.sendMessage ? (
                    <Badge bg={"light"} text={"dark"}>
                      ບໍ່ສາມາດທວງຍອດ
                    </Badge>
                  ) : (
                    <BsQuestionLg style={{ color: "orange" }} />
                  )}
                </td>
                <td
                  style={{
                    wordBreak: "break-word",
                    minWidth: 180,
                    fontSize: 14,
                  }}
                >
                  {getCfMessage(order?.orders ?? "-")}
                </td>
                {orderGroupType === "SALE_PAGE" && (
                  <td style={{ fontSize: 14 }}>
                    {order?.affiliateName ?? "-"}
                  </td>
                )}
                <td style={{ fontWeight: "bold" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ whiteSpace: "nowrap" }}>
                      ₭{" "}
                      {new Intl.NumberFormat("en-US").format(order?.totalPrice)}
                    </div>
                    {/* ບາດ/ໂດລາ ສ່ວນຫຼາຍເປັນ 0 — ໂຊທຸກແຖວເຮັດໃຫ້ແຖວສູງຂຶ້ນ 3 ເທົ່າເປົ່າໆ
                        ໂຊສະເພາະອັນທີ່ມີຄ່າຈິງ ຄົນຈຶ່ງເຫັນວ່າອໍເດີໃດມີສະກຸນເງິນອື່ນປົນ */}
                    {order?.sumPriceBaht > 0 && (
                      <div style={{ whiteSpace: "nowrap" }}>
                        ฿{" "}
                        {new Intl.NumberFormat("en-US").format(
                          order?.sumPriceBaht,
                        )}
                      </div>
                    )}
                    {order?.sumPriceUsd > 0 && (
                      <div style={{ whiteSpace: "nowrap" }}>
                        ${" "}
                        {new Intl.NumberFormat("en-US").format(
                          order?.sumPriceUsd,
                        )}
                      </div>
                    )}
                  </div>
                </td>
                <td>{moment(order?.createdAt).format("DD/MM/YYYY HH:mm")}</td>
                <td>
                  <DropdownButton
                    id="dropdown-item-button"
                    variant="outline-secondary"
                    title=""
                  >
                    <Dropdown.Item
                      as="button"
                      onClick={() => {
                        setSelectedOrderGroup(order);
                        setshowDetailModal(true);
                      }}
                    >
                      <FaEye style={{ marginLeft: "-.5em" }} /> ລາຍລະອຽດ
                    </Dropdown.Item>
                    <Dropdown.Item
                      as="button"
                      disabled={
                        order?.status === "COMPLETED" ||
                        order?.status === "CANCELLED"
                          ? true
                          : false
                      }
                      onClick={() => {
                        setSelectedOrderGroup(order);
                        handleOrderStatusChange();
                      }}
                    >
                      <FaEdit style={{ marginLeft: "-.5em" }} /> ແກ້ໄຂອໍເດີ້
                    </Dropdown.Item>
                    <Dropdown.Item
                      as="button"
                      onClick={() => handleCopyLinkLive(order?.id)}
                    >
                      <FaCopy style={{ marginLeft: "-.5em" }} /> ຄັດລ໋ອກລິ້ງ
                    </Dropdown.Item>
                    <Dropdown.Item
                      as="button"
                      hidden={!isUseLogistics}
                      disabled={
                        order?.status === "COMPLETED" ||
                        order?.status === "READY_TO_SHIPPING"
                          ? true
                          : false
                      }
                      onClick={() => handleCreatePreOrder(order)}
                    >
                      <FaLuggageCart style={{ marginLeft: "-.5em" }} /> ຈັດສົ່ງ
                    </Dropdown.Item>
                  </DropdownButton>
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  ); 
}

export default CreateOrderTable;
